module.exports = __webpack_public_path__ + "files/488f84d463293dc2eb5f5c9f32c63ef9.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bolditalic-webfont.ttf
 ** module id = 889
 ** module chunks = 0
 **/